/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        About: 'About', // 의미설명
        Reward: 'Reward', //
        RewardBot : 'RewardBot',
        Aim: 'Aim',
        AimBot: 'AimBot',
        Membership: 'Membership',
        ExplainLevel: 'ExplainLevel',
        WhatPV: 'WhatPV',
        ExplainPV: 'ExplainPV',
        WhatSmall: 'WhatSmall',
        ExplainSmall: 'ExplainSmall',
        GotIt: 'GotIt',
        LevelCondition: 'LevelCondition',
    },
    tomy:{
        kr: {
            About: '모든 분의 성공을 바라는 애터미만의 보상정책이 바로 마케팅 플랜입니다. {name}님께서도 꼭 아셔야 하는 정책이죠.', // 의미설명
            Reward: '오.. 어떤 보상이 있나요?', 
            RewardBot : '애터미에서는 사업자 회원분들 각자가 달성한 목표에 따라 수당을 지급하고 있습니다.',
            Aim: '어떤 수당이죠? ',
            AimBot: '총 4가지인데요, 회원등급, 후원수당, 직급수당, 교육수당으로 나뉘어 있죠.',
            Membership: '회원등급부터 알려주세요',
            ExplainLevel: '회원등급은 말 그대로 회원님의 등급에 따라 받는 수당입니다. 이 등급은 주로 누적 PV와 이전 달의 소실적 PV에 따라 정해져요.',
            WhatPV: 'PV가 무엇인가요?',
            ExplainPV: 'Point Value의 약자로서 애터미 상품을 구매하면 받을 수 있는 포인트입니다. 일반적인 포인트와는 달리 구매할 때 사용 할 순 없지만, 수당 산정의 기준이 됩니다.',
            WhatSmall: '그럼 소실적 PV는 뭔가요?',
            ExplainSmall: '본인의 좌우 하위회원 중 PV가 적은 쪽이 소실적이에요. 아래 예시는 우측이 소실적이네요. 지난달 좌우 회원의 PV가 회원님의 수당에도 영향을 미치는 거죠.',
            GotIt: '아하! 알겠어요.',
            LevelCondition: '회원등급 및 취득조건',
        },
        eng: {
            About: "Atomy's own compensation policy that strives for everyone's success is the marketing plan. This is a policy that {name} should also be aware of.", // 의미설명
            Reward: 'Oh.. what rewards are there?', //
            RewardBot : 'Atomy pays a commission according to the goals achieved by each business member.',
            Aim: 'what kind of allowance?',
            AimBot: 'There are a total of 4 types, and they are divided into mastership level, general commission, mastership bonus, and education commission.',
            Membership: 'Please tell us your membership level.',
            ExplainLevel: 'The membership level is literally the commission you receive according to your level. This rating is mainly based on the accumulated PV and the smaller PV of the previous month.',
            WhatPV: 'What is PV?',
            ExplainPV: 'As an abbreviation for Point Value, these are points that can be received by purchasing Atomy products. Unlike general points, they cannot be used for purchases, but rather they become the basis for calculating commissions.',
            WhatSmall: 'So what is smaller leg PV?',
            ExplainSmall: "The one with the lowest PV among the left and right downliners is more costly. In the example below, the right side is the smaller leg. The PV of the left and right downliners last month also affects the downliner's commission.",
            GotIt: 'Aha! I know.',
            LevelCondition: 'Membership Level and Acquisition Conditions',
        }
    },
    papa:{
        kr: {
            About: '애터미인 모두의 성공을 바라는 우리만의 보상정책이 바로 마케팅 플랜이에요. 사업자 회원이라면 꼭 알아야 하죠.', // 의미설명
            Reward: '오.. 어떤 보상이 있나요?', //
            RewardBot : '애터미에서는 사업자 회원 각자가 달성한 목표에 따라 수당을 지급하고 있어요.',
            Aim: '어떤 수당이죠? ',
            AimBot: '수당은 총 4가지가 있어요. 회원등급, 후원수당, 직급수당, 교육수당인데.. 어렵진 않아요!',
            Membership: '회원등급부터 알려주세요',
            ExplainLevel: '회원등급은 말 그대로 본인의 등급에 따라 받는 수당이에요. 이 등급은 주로 누적 PV와 이전 달의 소실적 PV에 따라 정해져요.',
            WhatPV: 'PV는 뭔가요?',
            ExplainPV: 'Point Value의 약자로서 애터미 상품을 구매하면 받을 수 있는 포인트입니다. 일반적인 포인트와는 달리 구매할 때 사용 할 순 없지만, 수당 산정의 기준이 됩니다.',
            WhatSmall: '그럼 소실적 PV는 뭔가요?',
            ExplainSmall: '본인의 좌우 하위회원 중 PV가 적은 쪽이 소실적이에요. 아래 예시는 우측이 소실적이네요. 지난달 좌우 회원의 PV가 본인의 수당에도 영향을 미치는 거죠.',
            GotIt: '아하! 알겠어요.',
            LevelCondition: '회원등급 및 취득조건',
        },
        eng: {
            About: "Our marketing plan is our own compensation policy that strives for the success of all Atomy people. If you're a business member, then you need to know about it.", // 의미설명
            Reward: 'Oh.. what rewards are there?', //
            RewardBot : 'Atomy pays commissions according to the goals achieved by each business member.',
            Aim: 'what kind of allowance?',
            AimBot: "There are a total of 4 commissions. Membership level, general commission, mastership bonus, education commission... It isn't too difficult!",
            Membership: 'Please tell us your membership level.',
            ExplainLevel: "The membership level is literally a commission you receive according to your level. This rating is mainly based on the accumulated PV and the smaller PV of the previous month.",
            WhatPV: 'What is PV?',
            ExplainPV: 'As an abbreviation for Point Value, these are points that can be received by purchasing Atomy products. Unlike general points, they cannot be used for purchases, but rather they become the basis for calculating allowances.',
            WhatSmall: 'So what is smaller leg PV?',
            ExplainSmall: "The one with the lowest PV among the left and right downliners is more costly. In the example below, the right side is smaller leg. The PV of the left and right downliners last month also affects the downliner's commision.",
            GotIt: 'Aha! I know.',
            LevelCondition: 'Membership Level and Acquisition Conditions',
        }
    },
};
